import { AfterViewInit, Component, OnInit } from '@angular/core'
import { GlobalService } from '../../../services/global.service'

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, AfterViewInit {
    showFooter = false

    constructor(public globalService: GlobalService) {}

    ngOnInit(): void {
        // Standard ParkUpp footer styling
        // Enterprise pages use dedicated footer components (e.g., app-redefine-footer)
        document.documentElement.style.setProperty('--whitelabel-color', '#001533')
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.showFooter = true
        }, 1000) // Delay of 1 second
    }
}
